import { IShipmentDocumentDownload, IShipmentDocumentUpload, useUpFetch } from '@repo/sdk'

export const useShipmentApi = (loadId: number) => {
  const upFetch = useUpFetch()

  const addShipmentDoc = async (document: IShipmentDocumentUpload) => {
    const formData = new FormData()

    formData.append('type', document.type ?? 'other')
    formData.append('files[]', document.file)

    await upFetch<{ data: IShipmentDocumentUpload }>(`/loads/${loadId}/documents`, {
      body: { files: document.file, type: document.type },
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      method: 'POST',
    })
  }

  const deleteShipmentDoc = async (documentId: number) => {
    await upFetch(`/loads/${loadId}/documents/${documentId}`, {
      method: 'DELETE',
    })
  }
  const getShipmentDocDownloadUrl = async (documentId: number) => {
    const res = await upFetch<{ url: IShipmentDocumentDownload['url'] }>(
      `/loads/${loadId}/documents/${documentId}/download`,
    )
    return res.url
  }

  return {
    addShipmentDoc,
    deleteShipmentDoc,
    getShipmentDocDownloadUrl,
  }
}
